import { ChecklistTaskDto as Task, SavedTask } from './checklist-task.model';
import { FileItem } from './file-item.model';

export class Checklist {
  checklist_name: string;
  checklist_id: string;
  created_at: string;
  created_by: string;
  purchase_order_id: string;
  checklist_tasks: Array<Task>;
  checklist_files: Array<FileItem>;
}

export class SavedChecklist {
  organization_id: string;
  created_at: string;
  created_by: string;
  saved_checklist_id: string;
  saved_checklist_name: string;
  saved_checklist_tasks: Array<SavedTask>;
}
